<template>
  <div v-if="show" class="ref-modal-backdrop">
    <div class="ref-modal-card">
      <!-- Header -->
      <div class="ref-modal-header">
        <h2 class="text-bold text-heading text-blue">Referensi Pendaftaran</h2>
        <button class="ref-modal-close" @click="$emit('close')">×</button>
      </div>

      <p class="ref-modal-subtitle">
        Darimana anda mengetahui info pendaftaran anggota Partai Perindo
      </p>

      <!-- Options -->
      <div class="ref-grid">
        <label
          v-for="item in options"
          :key="item.id"
          class="ref-option"
          :class="{ 'ref-option--other': isLainnya(item) }"
        >
          <!-- Radio -->
          <input
            type="radio"
            :value="item.id"
            v-model="localSelected"
          />
          <span class="radio-box"></span>

          <!-- Label -->
          <span class="ref-label">{{ item.name }}</span>

          <!-- Input untuk Lainnya -->
          <template v-if="isLainnya(item)">
            <input
              type="text"
              class="ref-other-input"
              placeholder="Tuliskan lainnya..."
              maxlength="90"
              v-model="localOtherText"
              :disabled="localSelected !== item.id"
            />
            <span class="ref-char-counter">
              {{ localOtherText.length }}/90
            </span>
          </template>
        </label>
      </div>

      <!-- Footer -->
      <div class="ref-modal-footer">
        <button class="btn-outline" @click="$emit('close')">Batal</button>
        <button
          class="btn-fill blue"
          :disabled="isSaveDisabled"
          @click.prevent="save"
        >
          Simpan
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    options: { type: Array, required: true }
  },
  data() {
    return {
      localSelected: "",
      localOtherText: ""
    }
  },
  computed: {
    isSaveDisabled() {
      // jika belum pilih apapun
      if (!this.localSelected) return true

      // jika Lainnya tapi text kosong
      if (this.localSelected === 6 && !this.localOtherText.trim()) return true

      return false
    }
  },
  methods: {
    isLainnya(item) {
      return item.id === 6
    },
    save() {
      this.$emit("save", {
        id: this.localSelected,
        lainnya_text: this.localSelected === 6 ? this.localOtherText.trim() : ""
      })
      this.$emit("close")
    }
  }
}
</script>

<style scoped>
/* BACKDROP */
.ref-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 1rem;
}

/* CARD */
.ref-modal-card {
  background: white;
  border-radius: 10px;
  max-width: 1280px;
  width: 100%;
  padding: 24px 32px;
}

/* HEADER */
.ref-modal-header {
  display: flex;
  justify-content: center;
  position: relative;
}

.ref-modal-subtitle {
  text-align: center;
  margin-top: 10px;
}

.ref-modal-close {
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

/* GRID */
.ref-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

/* OPTION */
.ref-option {
  background: #fff;
  border: 1px solid #ddd;
  padding: 10px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative; /* tambahkan ini */
}

/* RADIO */
.ref-option input[type="radio"] {
  position: absolute;
  left: 10px;              /* sesuaikan dengan padding/posisi radio-box */
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.radio-box {
  width: 16px;
  height: 16px;
  border: 1px solid #1f3b82;
  border-radius: 50%;
}

input[type="radio"]:checked + .radio-box {
  border-width: 5px;
}

/* OTHER OPTION */
.ref-other-input {
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  position: relative;
  z-index: 1;  /* naikkan di atas radio */
}

.ref-other-input {
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.ref-other-input:disabled {
  background: #f2f2f2;
}

.ref-char-counter {
  font-size: 11px;
  color: #888;
  white-space: nowrap;
}

/* FOOTER */
.ref-modal-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;

 .btn-outline,
  .btn-fill {
    min-width: 140px;
    border-radius: 8px;
    font-weight: 700;
    padding: 10px;
  }

  .btn-fill.blue:disabled {
    background: #d1d1d1 !important;
    color: #888 !important;
    border: none;
    cursor: not-allowed;
    box-shadow: none;
  }
}
</style>
